import { Crown } from "lucide-react";
import { RL, ST_CLS } from "@/components/partner/reportI18n";

const MEDAL = [
  { ring: "border-[#d4a017]", text: "text-[#d4a017]", bg: "bg-[#d4a017]/10", glow: "shadow-[0_0_0_4px_rgba(212,160,23,0.15)]" },
  { ring: "border-[#9aa3ad]", text: "text-[#9aa3ad]", bg: "bg-[#9aa3ad]/10", glow: "shadow-[0_0_0_4px_rgba(154,163,173,0.15)]" },
  { ring: "border-[#b87333]", text: "text-[#b87333]", bg: "bg-[#b87333]/10", glow: "shadow-[0_0_0_4px_rgba(184,115,51,0.15)]" },
];
const ORDER = [1, 0, 2];

export function Podium({ r, lang }) {
  const t = RL[lang];
  const top = r.students.slice(0, 3);
  if (!top.length) return null;
  const cols = ORDER.filter((i) => top[i]).map((i) => [i, top[i]]);
  return (
    <section className="soft-card p-5" data-testid="report-podium">
      <p className="text-xs uppercase tracking-wide text-muted-foreground">{t.podium}</p>
      <div className={`mt-4 grid gap-3 ${cols.length === 3 ? "sm:grid-cols-3 sm:items-end" : cols.length === 2 ? "sm:grid-cols-2" : "sm:grid-cols-1"}`}>
        {cols.map(([i, s]) => {
          const m = MEDAL[i];
          return (
            <div key={s.id} data-testid={`podium-${i + 1}`} className={`relative rounded-2xl border-2 ${m.ring} ${m.bg} ${m.glow} p-4 text-center ${i === 0 ? "sm:-translate-y-3 sm:py-6" : ""}`}>
              <Crown className={`mx-auto h-8 w-8 ${m.text}`} fill="currentColor" strokeWidth={1.5} />
              <p className={`mt-1 text-[11px] font-bold uppercase tracking-widest ${m.text}`}>#{i + 1}</p>
              <p className="mt-1 truncate font-semibold" title={s.name}>{s.name}</p>
              <p className="mt-1 font-jpserif text-3xl text-primary" data-testid={`podium-${i + 1}-score`}>{s.score}<span className="ml-1 text-xs text-muted-foreground">{t.pts}</span></p>
              <p className="mt-1 text-[11px] text-muted-foreground">{s.current_level || t.notyet} → {s.target_level}</p>
              <p className="mt-0.5 text-[11px] text-muted-foreground">{t.parts(s.score_parts)}</p>
              <span className={`mt-2 inline-block rounded-full px-2 py-0.5 text-[11px] font-semibold uppercase ${ST_CLS[s.status]}`}>{t.st[s.status]}</span>
            </div>
          );
        })}
      </div>
    </section>
  );
}
